import client from './axios';

const apiKeysUrl = `${window.__env.KRAKEND_URL}/v1/api-keys`;

export interface ApiKeyCreationBody {
  user: string;
  client: string;
  role: string;
}

export interface ApiKey {
  label: string;
  details: Record<string, string>;
  secret?: string;
  apiKey?: string;
}

export const ApiKeys = {
  createApiKey: (body: ApiKeyCreationBody) => client.post<ApiKey>(`${apiKeysUrl}`, body),
  getApiKeys: (params?: URLSearchParams) => client.get<any[]>(`${apiKeysUrl}`, { params }),
  deleteApiKey: (key: string) => client.delete(`${apiKeysUrl}/${key}`),
}